/**
 * A message another part of the app asked the assistant to send ("Ask the
 * assistant" buttons). The panel takes it once: a second take, from a re-run
 * effect or React StrictMode, gets nothing, so it is never sent twice.
 */
export interface PendingPrompt {
    /** Bumps each time a prompt is asked for, so the panel notices a new one. */
    nonce: number;
    /** The prompt, once; null after it has been taken. */
    take: () => string | null;
}

export interface PendingPromptBox {
    put: (text: string) => void;
    take: () => string | null;
}

export const createPendingPromptBox = (): PendingPromptBox => {
    let pending: string | null = null;
    return {
        put: text => {
            const trimmed = text.trim();
            pending = trimmed.length > 0 ? trimmed : null;
        },
        take: () => {
            const text = pending;
            pending = null;
            return text;
        }
    };
};
